export const isE2ETest = () => !!window.Cypress
